import React, { useState } from "react";
import { Button } from "react-bootstrap";
import WofButton from "../WofButton";
import "./styles.scss";
import VideoModal from "./VideoModal";
import CalendarInvitationCTA from "../CalendarInvitationCTA";

const PromoUnits: React.FC<any> = ({ promos, componentId }) => {
  const [videoModal, setVideoModal] = useState(false);
  const [videodata, setVideodata] = useState({});

  return (
    <div className="promo-small-units" id={componentId}>
      {(promos as any[]).map(
        (
          {
            description,
            title,
            image,
            alt,
            ctaText,
            ctaUrl,
            ctaIcon,
            type,
            ctabaseColor,
            ctahoverColor,
            videoUrl,
            jwMediaId,
            videoPlayOption,
            fullCardLinkUrl,
            calendarInvitationCTA
          },
          i
        ) => (
          <div key={`promo-unit-${i}`} className={"wrapper col-xs-12 " + type}>
            <div className="promo-single-unit">
              <div className="promo-img-wrap">
                {fullCardLinkUrl ? (
                  <a href={fullCardLinkUrl}>
                    <img src={image} alt={alt || title} />
                  </a>
                ) : (
                  <>
                    {" "}
                    <img src={image} alt={alt || title} />
                    <div>{fullCardLinkUrl}</div>
                  </>
                )}

                {videoPlayOption === "play_icon" && videoUrl ? (
                  <a
                    className={"play-btn"}
                    href="/"
                    onClick={(e) => {
                      setVideodata({
                        videoUrl: videoUrl,
                        jwMediaId: jwMediaId,
                        videoPlayOption: videoPlayOption,
                        image: image,
                        title: title,
                      });
                      e.preventDefault();
                      setVideoModal(true);
                    }}
                  />
                ) : null}
              </div>
              { title || description || ctaText || (calendarInvitationCTA && Object.keys(calendarInvitationCTA).length > 0 && Object.getPrototypeOf(calendarInvitationCTA) === Object.prototype) ? (
                  <div className="promo-bottom">
                    {title || description || type != 'col-md-12' ? (
                        <div className="promo-text">
                          {title || type != 'col-md-12' ? (
                            <h2 className="title" dangerouslySetInnerHTML={{__html: title}}></h2>
                            ) : null
                          }
                          {description || type != 'col-md-12' ? (
                            <div
                              className="description"
                              dangerouslySetInnerHTML={{
                                __html: description,
                              }}
                            />
                            ) : null
                          }
                        </div>
                        ) : null
                    }

                    <div className="promo-button">
                      {videoPlayOption === "cta" ? (
                        <Button
                          variant="primary"
                          onClick={(e: any) => {
                            setVideodata({
                              videoUrl: videoUrl,
                              jwMediaId: jwMediaId,
                              videoPlayOption: videoPlayOption,
                              image: image,
                              title: title,
                            });
                            e.preventDefault();
                            setVideoModal(true);
                          }}
                        >
                          {ctaText}
                        </Button>
                      ) : ctaUrl && ctaText ? (
                        <WofButton
                          baseColor={ctabaseColor}
                          hoverColor={ctahoverColor}
                          href={ctaUrl}
                          vType="primary"
                          faIcon={ctaIcon}
                        >
                          {ctaText}
                        </WofButton>
                      ) : null}
                      <CalendarInvitationCTA calendarEventData={calendarInvitationCTA} />
                    </div>
                  </div>
                  )
                : null
              }
            </div>
          </div>
        )
      )}
      <VideoModal
        onClose={() => setVideoModal(false)}
        show={videoModal}
        VideoModalData={videodata}
      />
    </div>
  );
};

export default PromoUnits;
